module.exports = __webpack_public_path__ + "static/media/logo.13365a65.png";